import { Injectable } from '@angular/core';
import { Observable } from "rxjs/Observable";
import { AppSettings } from "../app.settings";
import { AgentUtility } from "../util/agent.utility";
import {Base2Service} from "./base2.service";
import {ResponseApi} from "./response/response";

@Injectable()
export class CommissionService extends Base2Service {
    /** Вернет вознаграждения за текущий год для агента. */
    getCommission(): Observable<ResponseApi>{
        let agent = AgentUtility.getUser();

        return this.request<ResponseApi>("GET",AppSettings.apiUrl + 'commission/' + agent.Id);

    }
}

